import API, { defaultHeaders } from '../';

const login = async (payload = {}) => {
  const headers = Object.assign({}, defaultHeaders);
  return fetch(`${API}/login`, {
    method: 'post',
    headers,
    body: JSON.stringify(payload),
  });
};

export default login;
